export default {
  zoneSelected: null,
};
